import {
  LANGUAGE_CODES,
  LanguageCode,
  getTranslation,
  updateTranslation,
} from '../i18n/i18n'

export interface Food {
  id: number
  name?: string // 日本語名
  thumbnailImageFileName?: string
  thumbnailImageURL?: string
  index?: number
  foodTranslations?: FoodTranslation[] // 多言語翻訳データ
  price?: number
  brandCode?: string // ブランドコード（admin権限のみ有効）
  brandId?: number // ブランドID
  category?: string // カテゴリコード
  categoryDisplayName?: string // カテゴリ表示名
}

export interface FoodCategory {
  id: number
  brandId: number
  categoryCode: string
  displayName: string
}

export interface FoodTranslation {
  langCode: string // 言語コード
  name: string
}

export enum FoodImageType {
  ThumbnailImage = 'thumbnail_image',
}

export interface FoodImage {
  fileName?: string
  url?: string
  foodImageType?: FoodImageType
}

export const getFoodTranslation = (
  translations: FoodTranslation[] | undefined,
  selectedLanguageCode: LanguageCode
): FoodTranslation | undefined => {
  return getTranslation(translations, selectedLanguageCode)
}

// 翻訳データ作成ヘルパー関数
export const createEmptyFoodTranslations = (): FoodTranslation[] => [
  { langCode: LANGUAGE_CODES.JAPANESE, name: '' },
  { langCode: LANGUAGE_CODES.ENGLISH, name: '' },
]

// FoodTranslation用の更新関数
export const updateFoodTranslation = (
  translations: FoodTranslation[] | undefined,
  langCode: string,
  name: string
): FoodTranslation[] => {
  const currentTranslations = translations || []
  return updateTranslation(currentTranslations, langCode, { name })
}
